import { InternalSignerInfoLabelFragment } from "gql/graphql";
import { Email } from "@/shared/data-display/email";
import Avatar from "@/shared/data-display/avatar";
import { UserOutlined } from "@ant-design/icons";
import Text from "@/shared/typography/text";
import { LocalizedName } from "@/shared/data-display/localized-value";
import { Nothing } from "@/shared/value";

export function InternalSignerInfoLabel({
  externalInternalSignerInfo,
}: {
  externalInternalSignerInfo: InternalSignerInfoLabelFragment;
}) {
  return (
    <div className={"grid gap-y-1"}>
      <div className={"flex gap-2 items-center"}>
        <div>
          <Avatar
            icon={<UserOutlined />}
            src={externalInternalSignerInfo.person.avatar?.link}
          />
        </div>
        <div>
          <div>
            <Email email={externalInternalSignerInfo.person.email}>
              {externalInternalSignerInfo.person.lastName?.value}{" "}
              {externalInternalSignerInfo.person.firstName?.value}{" "}
              {externalInternalSignerInfo.person.middleName?.value}
            </Email>
          </div>

          <div>
            <Text as={"span"} color={"secondary"} type={"caption"}>
              <LocalizedName
                data={externalInternalSignerInfo.person.position?.name}
                whenEmpty={Nothing}
              />
            </Text>
          </div>

          <div>
            <Email email={externalInternalSignerInfo.person.email} />
          </div>
        </div>
      </div>
    </div>
  );
}
